/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
  /**
   * 用户登录
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postLogin(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/login',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 用户中心
   * @returns any 成功
   * @throws ApiError
   */
  static getUserCenter() {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/user/center'
    });
  }
  /**
   * 用户名 - 修改密码
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postUserPassword(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/user/password',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 用户名 - AccessKey管理 - 重新生成
   * @returns any 成功
   * @throws ApiError
   */
  static postUserAkRefresh() {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/user/ak/refresh'
    });
  }
}